<lib-gung-accordion #acc="gungAccordion" id="saved-cart-accordion" class="accordion-spacing">
  <lib-gung-accordion-item [customHeader]="true" [id]="cart.id" *ngFor="let cart of data; let i = index">
    <ng-template libGungAccordionHeader>
      <div class="row" style="place-content: center">
        <div class="d-flex flex-direction-row align-items-center col-12">
          <button class="btn btn-link text-dark col-4">
            {{ cart.name }} - {{ dateUtilService.parseDate(cart.creationDate) | date: dateUtilService.dateFormat }}
          </button>
          <button class="btn btn-link ml-auto col-4" (click)="loadCart(cart)" translate>LOAD_CART</button>
          <button class="btn btn-link col-2" (click)="fetchProductData(cart);showSavedCart(cart)" translate>SHOW_DETAILS</button>
          <div class="col-2">
            <button
              class="btn btn-link"
              (click)="addUserToCart(cart, $event); $event.preventDefault(); $event.stopPropagation()"
            >
              <i class="fa-solid fa-user-plus"></i>
            </button>
            <button class="btn btn-link" (click)="deleteCart(cart); $event.preventDefault(); $event.stopPropagation()">
              <i class="fas fa-trash-alt"></i>
            </button>
          </div>
        </div>
        <div style="font-size: x-small">
          <span *ngIf="cart.customerId" style="margin-right: 10px"
            ><span style="font-weight: bold" translate>CUSTOMER_ID</span>: {{ cart.customerId }}
          </span>
          <span *ngIf="cart.username"
            ><span style="font-weight: bold" translate>USER_ID</span>: {{ cart.username }}
          </span>
          <span *ngIf="cart.extra?.allowedUsername?.length > 0" class="d-block"
            ><span style="font-weight: bold" translate>ALLOWED_USERS</span>: {{ cart.extra.allowedUsername }}
          </span>
        </div>
      </div>
    </ng-template>

    <ng-template libGungAccordionBody>
      <div class="table-responsive overflow-hidden" *ngIf="mapData[cart.id]; else loading">
        <div class="row pl-3 pr-3 pb-3 justify-content-end" *ngIf="saveData[cart.id]">
          <button class="btn btn-primary" (click)="saveCartOrder(i, $event)" translate>SAVE</button>
        </div>
        <table class="table table-sm table-borderless table-striped">
          <thead>
            <tr>
              <th class="td-id"><span translate>PRODUCT_ID</span></th>
              <th class="td-name"><span translate>NAME</span></th>
              <th class="td-qty"><span translate>QTY</span></th>
              <th class="td-price"><span translate>PRICE</span></th>
              <th class="td-move"></th>
            </tr>
          </thead>
          <tbody cdkDropList (cdkDropListDropped)="drop(i, $event)" class="drag-list">
            <tr *ngFor="let row of mapData[cart.id]" class="dragable-item" cdkDrag>
              <td class="td-id">
                <ng-container *ngIf="row.productId !== freeTextProductId">
                  <a [routerLink]="['/product/', row.productId]">
                    {{ row.productId }}
                  </a>
                </ng-container>
              </td>
              <td class="td-name">
                {{ row.productId === freeTextProductId ? (row.extra?.orp?.artbeskr || row?.product?.name) : row?.product?.name }}
              </td>
              <td class="td-qty">
                {{ row.qty }}
              </td>
              <td class="td-price">
                <lib-price
                  [price]="row?.product?.extra?.price?.value"
                  [currency]="row?.product?.extra?.price?.currencyCode"
                ></lib-price>
              </td>
              <td class="td-move flex-row flex-nowrap justify-content-center align-items-center">
                <i class="fas fa-arrows-alt fa-lg drag-handle" cdkDragHandle></i>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td translate>SUMMARY</td>
              <td></td>
              <td></td>
              <td>
                <lib-price [price]="totalPriceByCart[cart.id] || totalPrice" [currency]="currencyCode"></lib-price>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </ng-template>
  </lib-gung-accordion-item>
</lib-gung-accordion>

<ng-template #loading>
  <div class="row">
    <div class="col-12 m-2 p-2 text-center">
      <i class="fa fa-spinner fa-spin-lg"></i>
    </div>
  </div>
</ng-template>
